import { Stack, Typography } from '@mui/material';
import { BasicConfirmDialog } from 'features/ui/base-dialogs';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  questionnaireName: string;

  handleClose(): void;

  handleConfirm(): void;
}

const ConfirmDeleteQuestionnaireDialog: React.FC<Props> = ({ open, questionnaireName, handleClose, handleConfirm }) => {
  const { classes } = useStyles();

  return (
    <BasicConfirmDialog
      open={open}
      title={'Fragebogen löschen'}
      confirmButton={'Ok'}
      cancelButton={'Abbrechen'}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
    >
      <Stack gap={1}>
        <Typography className={classes.text}>{`Sind Sie sicher, dass Sie den Fragebogen ${questionnaireName} wirklich löschen möchten?`}</Typography>
        <Typography className={classes.text}>Der Vorgang ist nicht umkehrbar und der Fragebogen steht danach nicht mehr zur Verfügung.</Typography>
      </Stack>
    </BasicConfirmDialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  text: {
    fontSize: theme.typography.pxToRem(13),
    whiteSpace: 'pre-wrap',
  },
}));

export default ConfirmDeleteQuestionnaireDialog;
